import FormController from "components/Molecules/FormController"
import { useAllBanksSelectorQuery } from "generated/graphql"
import React from "react"
import useDCStore from "../dc.store"
import FormLayout from "../FormLayout"
import PaymentMethod from "./PaymentMethod"
const PaymentMethods = () => {
  const [paymentMethods, errors, onChange, addListItem] = useDCStore(store => [
    store.state.paymentMethods ?? [],
    store.errors.paymentMethods,
    store.setData("paymentMethods"),
    store.addListItem,
  ])
  const { data } = useAllBanksSelectorQuery()
  const allBanks = data?.allBanks
  return (
    <FormController errors={errors} source={paymentMethods} onChange={onChange}>
      <FormLayout
        title="Payment Methods"
        onAdd={() => addListItem("paymentMethods", {})}
      >
        {paymentMethods.map((method, index) => (
          <PaymentMethod
            allBanks={allBanks}
            key={index}
            data={method}
            index={index}
          />
        ))}
      </FormLayout>
    </FormController>
  )
}

export default PaymentMethods
